import React from "react";

const TransSummaryComp = ({ sum }) => {
  // Long values/descriptions stay on one line and truncate inside the card
  const valueTitle =
    typeof sum?.value === "string" || typeof sum?.value === "number"
      ? String(sum.value)
      : undefined;
  return (
    <div className={` ${sum?.conClass} min-w-0 gap-2`}>
      <div className="flex flex-col min-w-0 flex-1">
        <div className={`${sum?.labelClass} truncate`}>{sum?.label}</div>
        <p className={`${sum?.valueClass} truncate`} title={valueTitle}>
          {sum?.value}
        </p>
        <div
          className={`${sum?.descClass} mt-2 whitespace-nowrap overflow-hidden text-ellipsis`}
        >
          {sum?.desc}
        </div>
      </div>
      <div className="shrink-0">{sum?.icon}</div>
    </div>
  );
};

export default TransSummaryComp;
